import React, { Fragment } from "react"
import PropTypes from "prop-types"
import styled from "react-emotion"
import { get, set } from "lodash"

import { Text, Container, Checkbox } from "ui"
import WithObjects from "data/wrappers/WithObjects"

const deepcopy = require("deepcopy")

export default class StandardPagesListEditor extends React.Component {
    render() {
        return (
            <Container>
                <Table>
                    <WithObjects>{({ objects }) => objects.map(this.renderObjectRow)}</WithObjects>
                </Table>
            </Container>
        )
    }

    renderObjectRow = object => (
        <Fragment>
            {["detail", "list"].map(type => this.renderStandardPageRow(object, type))}
        </Fragment>
    )

    renderStandardPageRow = (object, type) => {
        const routeSuffix = type == "detail" ? "/<id>/" : ""
        const objectName = type == "detail" ? object.name : ""
        return (
            <tr>
                <td>
                    <TableText> {objectName}</TableText>
                </td>
                <td>
                    <TableText>{type}</TableText>
                </td>
                <td>
                    <TableText>
                        /{object.api_name}
                        {routeSuffix}
                    </TableText>
                </td>
                <td>{this.renderEnableStandardPageCheckbox(object, type)}</td>
            </tr>
        )
    }

    renderEnableStandardPageCheckbox = (object, type) => {
        const standardPages = deepcopy(this.props.standardPages) || {}
        const isEnabled = get(standardPages, `${object._sid}.${type}.enabled`, "true")
        const toggle = () => {
            const updatedStandardPages = set(
                standardPages,
                `${object._sid}.${type}.enabled`,
                !isEnabled
            )
            this.props.onChange(updatedStandardPages)
        }
        return <Checkbox value={isEnabled} onChange={toggle} />
    }
}

const Table = styled("table")`
    width: 100%;
`

const TableText = props => <Text {...props} margin="none" />



// WEBPACK FOOTER //
// ./src/features/studio/components/StandardPagesListEditor.js